// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"4e4567e6","997":"b4d78006"}[chunkId] + ".chunk.js";
};